import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RiskFlaggingPage } from "@/components/risk-flagging";

const searchSchema = z.object({
  view: z.enum(["alerts", "reports"]).optional(),
  alertId: z.string().uuid().optional(),
  reportId: z.string().uuid().optional(),
});

export const Route = createFileRoute("/_authenticated/risk-flagging/")({
  component: RiskFlaggingPage,
  validateSearch: searchSchema,
});
